import { useState } from "react";
import "./Register.css";
const API =
  process.env.REACT_APP_API ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:5000";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [sub, setSub] = useState(false);
  const [err, setErr] = useState("");

  async function onSubmit(e) {
  e.preventDefault();
  if (sub) return;
  setSub(true);
  setErr("");

  try {
    const r = await fetch(`${API}/api/auth/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ name, email, password: pwd }),
    });

    if (!r.ok) {
      let msg = "Falha ao criar conta.";
      try {
        const data = await r.json();
        if (data?.error === "email_exists") {
          msg = "Já existe uma conta com este email.";
        } else if (data?.error === "password_too_short") {
          msg = "A password é demasiado curta.";
        } else if (typeof data?.error === "string") {
          msg = data.error;
        }
      } catch {
        // se não conseguir ler JSON, fica a mensagem genérica
      }
      throw new Error(msg);
    }

    // Sucesso
    setName("");
    setEmail("");
    setPwd("");
    alert("Conta criada. Já podes iniciar sessão.");
  } catch (e) {
    setErr(e.message || "Erro inesperado.");
  } finally {
    setSub(false);
  }
}


  return (
    <div className="auth-page py-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-7 col-xl-5">
            <h1 className="auth-title h2 mb-3">Criar conta</h1>

            <div className="auth-card p-4 p-md-4">
              <form onSubmit={onSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label">Nome</label>
                  <input
                    className="form-control"
                    value={name}
                    onChange={(e)=>setName(e.target.value)}
                    autoComplete="name" required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                    autoComplete="email" required
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={pwd}
                    onChange={(e)=>setPwd(e.target.value)}
                    autoComplete="new-password" required minLength={6}
                  />
                </div>

                {err && <div className="alert alert-danger mb-3">{err}</div>}

                <button className="btn btn-primary w-100" disabled={sub}>
                  {sub ? "A criar..." : "Criar conta"}
                </button>
              </form>
            </div>

            <div className="text-muted small mt-3">
              Já tens conta? <a href="/login">Inicia sessão</a>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
